// extracted by mini-css-extract-plugin
export var callCard = "_ru-0";
export var callMessageButton = "_ru-1";
export var helpIcon = "_ru-3";
export var helpIconContainer = "_ru-4";
export var verticalDivider = "_ru-2";